







import Vue from 'vue';
import Layout from '@/layouts/ErrorLayout.vue';
import NotFound from './components/NotFound.vue';

export default Vue.extend({
    name: 'NotFoundPage',
    components: {
        Layout,
        NotFound,
    },
    metaInfo: {
        title: 'Страница не найдена 404',
    }
});
